/*
  Order-bron als cart-attributen — Sableau

  Sinds de checkout bij Lasso draait (07-09-2026) maakt Lasso de Shopify-order via zijn app.
  Shopify's eigen bron-registratie (customer journey, sessies → checkout) staat daardoor op nul en
  alleen orders waar Lasso toevallig utm's in de URL zag, dragen een bron. Lasso kopieert
  cart-attributen wél één-op-één naar de order (bewezen: __essential_cart_* staat op elke order).

  Dus: utm_*, ttclid/fbclid en de verwijzer bij binnenkomst onthouden (last click, 30 dagen) en
  1) als verborgen velden in elk add-to-cart-formulier stoppen — dan reizen ze vanaf de eerste
     add mee met de winkelwagen, zonder extra verzoek;
  2) één keer per sessie de bestaande winkelwagen bijwerken, voor adds die niet via een formulier
     gaan (quick-add, app-drawer).
  Attributen beginnen met een underscore: Shopify en Lasso tonen die niet aan de klant.

  Eerste klik + bezoeken (12-10-2026, plan docs/ops/attributie/PLAN-attributie-2026-10-12.md laag B):
  de laatste klik zegt niet welke ad iemand voor het eerst binnenbracht. Daarom ook de bron van het
  allereerste bezoek in deze browser (ook "direct"), het aantal bezoeken en de dagen sinds dat eerste
  bezoek: `_first_utm_source`, `_first_utm_content`, `_first_landing`, `_first_days`, `_visits`.
  Blijft 180 dagen; staat los van de laatste-klik-opslag.
*/
(function () {
  'use strict';

  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ttclid', 'fbclid'];
  var STORE = 'sableau:source';
  var TTL_MS = 30 * 24 * 3600 * 1000;
  var FIRST = 'sableau:first';
  var FIRST_TTL_MS = 180 * 24 * 3600 * 1000;

  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE) || 'null');
      return v && v.ts && Date.now() - v.ts < TTL_MS ? v : null;
    } catch (e) { return null; }
  }

  function capture() {
    var search = location.search;
    try { search = sessionStorage.getItem('sableau:landing-search') || search; } catch (e) {}
    var q = new URLSearchParams(search);
    var out = {}, hit = false;
    KEYS.forEach(function (k) { var v = q.get(k); if (v) { out[k] = String(v).slice(0, 120); hit = true; } });
    if (!out.ttclid) {
      var m = document.cookie.match(/(?:^|;\s*)ttclid=([^;]+)/);
      if (m) {
        // 14-10: zonder query-parameters is de cookie meestal hetzelfde TikTok-bezoek op een volgende
        // pagina. Die mag de opgeslagen klik (met ad-naam) niet overschrijven: 13-10 telde de trechter
        // daardoor 0 TikTok-orders terwijl er wél waren (#41895, #41896 hadden alleen nog `_ttclid`).
        var prev = !hit && load();
        if (prev && prev.ttclid) return prev;
        if (!hit) out.utm_source = 'tiktok';
        out.ttclid = decodeURIComponent(m[1]).slice(0, 120); hit = true;
      }
    }
    if (!hit) {
      var ref = document.referrer;
      if (ref && ref.indexOf('//' + location.host) === -1) {
        try { out.utm_source = new URL(ref).hostname.replace(/^www\./, ''); out.utm_medium = 'referral'; hit = true; } catch (e) {}
      }
    }
    if (!hit) return load();
    try { sessionStorage.removeItem('sableau:landing-search'); } catch (e) {}
    out.landing = location.pathname.slice(0, 120);
    out.ts = Date.now();
    try { localStorage.setItem(STORE, JSON.stringify(out)); } catch (e) {}
    return out;
  }

  // Wallet-bereik meten (11-09-2026). Apple Pay was 39,7 % van de 451 orders uit de periode dat élke
  // methode nog kon, dus de hele checkout is erop gebouwd — maar Apple Pay op het web bestaat alleen
  // in Safari. In de in-app browser van TikTok (een WKWebView zonder Apple Pay-entitlement) verschijnt
  // de knop niet, en 94,8 % van ons verkeer is mobiel en komt uit TikTok-advertenties. Whop's API kan
  // het ons niet vertellen: `payment_instrument` was leeg op alle 86 betalingen. Deze twee attributen
  // reizen met de winkelwagen mee naar de order, zodat we per order kunnen tellen wie de knop
  // überhaupt kón zien, in plaats van erover te gokken.
  function walletSupport() {
    var out = [];
    try { if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) out.push('applepay'); } catch (e) {}
    if (window.PaymentRequest) out.push('paymentrequest');
    return out.join('+') || 'none';
  }

  /* Welke checkout-deur deze bezoeker kreeg, en op welk land die keuze is gebaseerd (12-09-2026).
     snippets/payment-route.liquid kiest op `localization.country.iso_code` — de markt-/keuzelandcode, niet het
     bezorgadres. Een Noorse klant die op een EUR-markt binnenkomt, krijgt dus de Whop-deur en precies de
     kaartweigering waar de splitsing voor gemaakt is. Dat is niet in Liquid op te lossen (op de winkelwagen
     bestaat het bezorgadres nog niet), maar het is wél te meten: deze twee attributen reizen met de order mee,
     zodat je achteraf deur × land × weigering naast elkaar kunt leggen. De deur lezen we aan het enige harde
     bewijs op de pagina: staat het Lasso-script er, dan gaat de afrekenknop naar Whop. */
  function checkoutRoute() {
    return document.querySelector('script[src*="lasso-script"]') ? 'whop' : 'revolut';
  }

  function marketCountry() {
    try { return (window.Shopify && window.Shopify.country) || ''; } catch (e) { return ''; }
  }

  function browserKind() {
    var ua = navigator.userAgent || '';
    if (/BytedanceWebview|musical_ly|TikTok|Bytedance/i.test(ua)) return 'tiktok-inapp';
    if (/Instagram/i.test(ua)) return 'instagram-inapp';
    if (/FBAN|FBAV|FB_IAB/i.test(ua)) return 'facebook-inapp';
    if (/Snapchat/i.test(ua)) return 'snapchat-inapp';
    return 'browser';
  }

  var src = capture();

  // Eerste bezoek en bezoekteller. Een bezoek = een nieuwe tab-sessie (sessionStorage leeg).
  function firstTouch(src) {
    var f = null;
    try { f = JSON.parse(localStorage.getItem(FIRST) || 'null'); } catch (e) {}
    if (!f || !f.ts || Date.now() - f.ts > FIRST_TTL_MS) {
      // Alleen een bron die bij dít bezoek binnenkwam; een oude laatste klik uit load() is geen eerste bezoek.
      var fresh = src && src.ts && Date.now() - src.ts < 5000;
      f = { utm_source: fresh ? (src.utm_source || (src.ttclid ? 'tiktok' : '')) : 'direct', utm_content: fresh ? (src.utm_content || '') : '',
        landing: location.pathname.slice(0, 120), ts: Date.now(), visits: 0 };
    }
    var nieuw = false;
    try { nieuw = sessionStorage.getItem(FIRST + ':seen') !== '1'; sessionStorage.setItem(FIRST + ':seen', '1'); } catch (e) {}
    if (nieuw) f.visits = (f.visits || 0) + 1;
    try { localStorage.setItem(FIRST, JSON.stringify(f)); } catch (e) {}
    return f;
  }
  var first = firstTouch(src);

  var attrs = {};
  if (src) Object.keys(src).forEach(function (k) { if (k !== 'ts') attrs['_' + k] = String(src[k]); });
  attrs._wallet = walletSupport();
  attrs._browser = browserKind();
  attrs._route = checkoutRoute();
  attrs._market = marketCountry();
  if (first) {
    attrs._first_utm_source = String(first.utm_source || 'direct');
    if (first.utm_content) attrs._first_utm_content = String(first.utm_content);
    attrs._first_landing = String(first.landing || '');
    attrs._first_days = String(Math.floor((Date.now() - first.ts) / 86400000));
    attrs._visits = String(first.visits || 1);
  }
  // A/B euro-teken (24-10-2026, store/sableau/ab-euro-2026-10-24): which theme arm this visitor saw. layout/theme.liquid
  // sets window.SB_AB ('control' = prices without the euro sign, 'euro' = with). Shopify Rollouts does not put the arm on
  // the order, so it travels as a cart attribute; the same value goes to Clarity as a tag (sessions per arm there).
  attrs._ab = String(window.SB_AB || 'none');
  (function tag(n) {
    if (window.clarity) { try { window.clarity('set', 'ab_euro', attrs._ab); } catch (e) {} }
    else if (n > 0 && typeof setTimeout === 'function') setTimeout(function () { tag(n - 1); }, 1000); // agents/test runs this in a bare vm
  })(10);

  // 1) verborgen velden. Het thema (Horizon) bindt zijn eigen submit-handler via delegatie op
  //    document in de capture-fase, vóór dit script; een submit-listener komt dus te laat. De
  //    klik op de knop gaat eraan vooraf — daar de velden zetten, zodat ook later ingevoegde
  //    formulieren (quick-add, sticky bar) meegaan.
  function decorate(form) {
    if (!form || form.__sbSource) return;
    if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    form.__sbSource = true;
    Object.keys(attrs).forEach(function (k) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + k + ']';
      input.value = attrs[k];
      form.appendChild(input);
    });
  }
  document.addEventListener('click', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    var button = t && t.closest('button, input[type="submit"]');
    if (!button) return;
    decorate(button.form || button.closest('form'));
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target instanceof HTMLFormElement) decorate(event.target);
  }, true);

  // 2) bestaande winkelwagen één keer per sessie bijwerken.
  function synced(v) { try { if (v === undefined) return sessionStorage.getItem(STORE + ':synced') === '1'; sessionStorage.setItem(STORE + ':synced', '1'); } catch (e) { return false; } }
  // Code via een link (/discount/CODE, bv. uit een verlaten-mandje-mail) zet Shopify server-side op de wagen. Lasso neemt de
  // wagen alleen over na een JS-cart-POST en leest hem niet opnieuw bij "afrekenen" (lasso-script-v4, 20-10): zonder POST
  // betaalde de klant in 2 van 3 tests de volle prijs. Nieuwe code in de cookie = één keer opnieuw POSTen.
  function linkCode() { var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/); return m ? decodeURIComponent(m[1]) : ''; }
  function codeSynced(v) { try { if (v === undefined) return sessionStorage.getItem(STORE + ':code') || ''; sessionStorage.setItem(STORE + ':code', v); } catch (e) { return ''; } }
  function sync() {
    var code = linkCode();
    if (synced() && code === codeSynced()) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        var have = cart.attributes || {};
        // Marker "al bijgewerkt" = het jóngste attribuut dat we schrijven, nu `_route` (12-09-2026).
        // Stond op `_browser`; een winkelwagen van tussen 11-09 en 12-09 had dat wél en zou de nieuwe
        // deur-/marktvelden dus nooit meer krijgen. De marker moet meeschuiven met wat we toevoegen.
        // 12-10: marker `_visits` (jongste veld). Bezoekteller verandert per sessie, dus bijwerken zodra hij afwijkt.
        // 24-10: ook `_ab` (A/B-arm); een wagen van vóór de test krijgt hem zo alsnog.
        if (have._visits === attrs._visits && have._ab === attrs._ab && code === codeSynced()) { synced(true); return; }
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
        }).then(function () { synced(true); codeSynced(code); });
      })
      .catch(function () {});
  }
  if (document.readyState === 'complete') sync();
  else window.addEventListener('load', sync, { once: true });
})();
